import { useEffect, useState } from "react";
import { LoyaltyApi } from "@jti/rest-api";
import { useLoyaltyRestrictedContent } from "../useLoyaltyRestrictedContent";
export const useLoyalty = () => {
    const [isActive, setIsActive] = useState(false);
    const { isRestricted, isLoyaltyEnabled } = useLoyaltyRestrictedContent();
    useEffect(() => {
        if (isLoyaltyEnabled && !isRestricted) {
            LoyaltyApi.init()
                .getStatus()
                .then((response) => {
                setIsActive(response);
            })
                .catch(() => {
                setIsActive(false);
            });
        }
    }, [isLoyaltyEnabled, isRestricted]);
    return isActive;
};
//# sourceMappingURL=useLoyalty.js.map